import React, { useContext } from "react";
import { StepContext } from "../App";

import logo from "../vanchanger_logo_horizontal_white.svg";

const steps = [
	"Fahrzeug",
	"Innenraum",
	"Sitze",
	"Technik",
	"Gadgets",
	"Übersicht",
];

function Header() {
	const [ step, setStep ] = useContext( StepContext );

	return <header>
		<nav className="nav">
			<a className="flex nav-logo-link" href="https://vanchanger.de">
				<div className="nav-logo">
					<img src={logo} alt={"VanChanger Logo"} />
				</div>
			</a>
			<ul className="flex nav-ul">

				{steps.map( ( s, i ) => <li className="nav-ul-li" key={s}>
					<button className={`nav-ul-li-a` + ( step === i ? " active" : "" )}
					        onClick={() => setStep( i )}>{s}</button>
				</li> )}
			</ul>
		</nav>
	</header>;
}

export default Header;
